export default {
  isInBounds(point, bounds) {
    const lng =
      (point.lng - bounds._northEast.lng) *
        (point.lng - bounds._southWest.lng) <
      0
    const lat =
      (point.lat - bounds._northEast.lat) *
        (point.lat - bounds._southWest.lat) <
      0
    return lng && lat
  },
}
